import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/Home', 
    component: ()=> import ('../views/HomePage.vue')
  },
  {
    path: '/Home',
    name: 'Home',
    component: ()=> import ('../views/HomePage.vue')
  },
  {
    path: '/contact',
    name: 'Contact us',
    component: ()=> import ('../views/Contact.vue')
  },
  {
    path: '/products',
   name: 'Products',
    component: ()=> import ('../views/Products.vue')
  },
  {
    path: '/demo',
    name: 'Demo',
    component: ()=> import ('../views/Demo.vue')
  }
  // {
  //   path: '/about-us',
  //   name: 'AboutUs',
  //   component: ()=> import ('../views/AboutUs.vue')
  // }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Start new pages at the top; restore position on back/forward
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.path === from.path) return false;
    return { top: 0 };
  },
});

export default router;
